import { Route } from '@angular/router';

import { APP_ROUTE_PATHS } from '@ps/core-config';
import { UserType } from '@ps/core-models';
import {
  dashboardPreferencesResolver,
  featureFlagGuard,
  roleGuard,
} from '@ps/user-settings-data-access';

export const COMMON_ROUTES: Route[] = [
  {
    path: APP_ROUTE_PATHS.resetPassword,
    loadComponent: () =>
      import('../pages/auth/reset-password/reset-password.page').then(
        (m) => m.ResetPasswordPage,
      ),
    title: 'Reset Password',
  },
  {
    path: APP_ROUTE_PATHS.dashboard,
    resolve: { preferences: dashboardPreferencesResolver },
    loadComponent: () =>
      import('../pages/dashboard/dashboard.page').then((m) => m.DashboardPage),
    title: 'Dashboard',
  },
  {
    path: APP_ROUTE_PATHS.invoiceOperations,
    canActivate: [roleGuard],
    data: { deniedRoles: ['supplier'] as UserType[] },
    loadComponent: () =>
      import('../pages/invoice/invoice-operations.page').then(
        (m) => m.InvoiceOperationsPage,
      ),
    title: 'Invoice Operations',
  },
  {
    path: APP_ROUTE_PATHS.downloadReports,
    loadComponent: () =>
      import('@ps/download-reports-feature').then(
        (m) => m.DownloadReportsComponent,
      ),
    title: 'Download Reports',
  },
  {
    path: APP_ROUTE_PATHS.questionLibrary,
    canActivate: [roleGuard, featureFlagGuard],
    data: {
      deniedRoles: ['supplier'] as UserType[],
      flagName: 'enableQuestionLibrary',
    },
    loadComponent: () =>
      import('../pages/question/question-library/question-library.page').then(
        (m) => m.QuestionLibraryPage,
      ),
    title: 'Question Library',
  },
  {
    path: APP_ROUTE_PATHS.irGenerator,
    canActivate: [roleGuard],
    data: { deniedRoles: ['supplier'] as UserType[] },
    loadComponent: () =>
      import('../pages/ai-assistant/ir-generator/ir-generator.page').then(
        (m) => m.IrGeneratorPage,
      ),
    title: 'IR Generator',
  },
];
